import { useAuth0 } from '@auth0/auth0-react';
import { ApiErrorWrapper, useApi } from '@hooks/api.hook.tsx';
import { queryKeys } from '@queries/keys.ts';
import { useQuery } from '@tanstack/react-query';
import { OperationalIntegrationSelectDto, OperationalIntegrationsSelectDto } from '../types/api.types';

export const useGetOperationalIntegrations = () => {
  const { apiGet } = useApi();
  const { isAuthenticated } = useAuth0();
  const enabled = Boolean(isAuthenticated);

  return useQuery<OperationalIntegrationSelectDto[], ApiErrorWrapper>({
    enabled,
    queryFn: async () => {
      const result = await apiGet<OperationalIntegrationsSelectDto>({
        path: '/v1/data/operational-integrations',
      });
      return result.operationalIntegrations;
    },
    queryKey: enabled ? queryKeys.operationalIntegration.getOperationalIntegrations : queryKeys.placeholders.default,
  });
};
